module.exports = __webpack_public_path__ + "img/west-spring-768x550.5449eac8.jpg";